<script>
	// svelte/d3 libs
	import { scaleLinear } from 'd3-scale';
	import { elasticOut, linear, quartIn, cubicOut } from 'svelte/easing';



    import State from '../stores/State.js'; 
	import inView from '../actions/inView.js';

	import { tweened } from 'svelte/motion';
	import { fade, fly, scale } from 'svelte/transition';
	import { flip } from 'svelte/animate';
	import { onMount } from 'svelte';

	export let placePlaying = false;

	// data
    import points from '../data/pointsData.js';
	// export let driverLastLaps;
	// export let scrollValue;
	// // just stopping warning will fill in later
	// if(scrollValue) {};

	let dPoints = [];
	let raceCount = 1;
	let newPoints = [];
	let timeouts = [];
	// let colors = ['#ff3263', '#cf468c', '#905995', '#3b628e']
	// let colors = ['#ff3263', '#c12d4d', '#872637', '#3b628e', '#1a4771', '#325984', '#476c96', '#5c7fa8', '#7193bb', '#87a7cd', '#9cbce0']
	let colors = ['#ff3263', '#26A1F5', '#26A1F5', '#004075', '#004075', '#004075', '#004075', '#004075', '#004075', '#004075', '#004075']

	const xTicks = [100, 200, 300, 400];



	function clearTimeouts (){
		timeouts.forEach (t => {
			clearTimeout(t)
		});
		timeouts = [];
	}

import { debug } from 'svelte/internal';

	
	


	function showTooltip(driver, raceDeets){
		if (!placePlaying){
			ttDriver = driver;
			ttRace = raceDeets.race;
			ttPos = raceDeets.pos;
			ttPoints = raceDeets.points;
			// ttExtra = raceDeets.extra;
		}
	}

	function hideTooltip(){
		if (!placePlaying){
			ttDriver = "";
			ttRace = "";
			this.blur();
		}
	}

	function getRace (raceNum) {
		let newPoints = []
		if (typeof points[raceNum] === 'undefined') return newPoints;
		const r = points[raceNum]
		r.drivers.forEach((d) => {
			const {driver, ...races} = d;
			newPoints = [...newPoints, {"driver":driver, "rank":races.rank,  "races":[races]}];
		});
		ttRace = r.race;
		return newPoints;
	}

	function addNewPoints(dPoints, newPoints){
		newPoints.forEach((d) => {
			const j = dPoints.findIndex(o => o.driver === d.driver)
			if (j > -1) {
				dPoints[j].races.push(d.races[0]);
				dPoints[j].rank = d.races[0].rank;
			}
			else{
				dPoints.push({"driver":d.driver, "rank":d.races[0].rank,  "races":d.races});
			}
		});
		return dPoints;
	}



	function fullyPopPoints () {
		let i = 0
		while (i < 22) {
			const np = getRace(i);
			dPoints = addNewPoints(dPoints, np);
			i++;
		}
		ttRace = "";
	}
	
	export function replay() {
		stopReplay();
		placePlaying = true;
		newPoints = [];
		dPoints = [];
		raceCount = 0;
		while (raceCount < 22) {
			const i = raceCount
			//timeouts.push(setTimeout(() => { newPoints = getRace(i) ;}, 1000 * i));
			timeouts.push(setTimeout(() => { dPoints = addNewPoints(dPoints, getRace(i));}, 1000 * i));
			raceCount++;
		}
		timeouts.push(setTimeout(() => { placePlaying = false ; ttRace = ""}, 1000 * 22));
	}

	export function stopReplay() {
		timeouts.forEach((v) => {clearTimeout(v);});
		placePlaying = false;
		timeouts = [];
		dPoints=[];
		fullyPopPoints();
	}

	// function getTextColor (pos){
	// 	if (pos === 1) {return '#FF3263'} 
	// 	else if (pos === 2 || pos === 3) {return '#9CBCE0'}
	// 	else {return '#5C86B5'}
	// }


	onMount(() => {
		if ($State.prevChart === 'Finish' && $State.selRace.race === 'Bahrain' && intro && !$State.placesFirstVisible) {
			newPoints = getRace(0);
			timeouts.push(setTimeout(() => { slide = false ;}, 200));
			timeouts.push(setTimeout(() => { intro = false ;}, 1000));
			timeouts.push(setTimeout(() => { replay() ;}, 1000));
		}
		else {
			fullyPopPoints();
		}

	});

	let width = 900;

	const padding = { top: 35, right: 25, bottom: 70, left: 110 };

	$: xExtent = [0, 395.5];	

	$: $State.p_x = scaleLinear()
		.domain(xExtent)
		.range([0, width - padding.right - padding.left]);

	// $: $State.p_y = scaleLinear()
	// 	.domain([1, 10])
	// 	.range([padding.top, height - padding.bottom]);

	let ttDriver = "";
	let ttRace = "";
	let ttPos = "";
	let ttPoints = "";
	let ttExtra = "";

	let intro = true;
	let slide = true;
</script>
	

<container>
<div class="chart" id="placeChart"	bind:clientWidth={width} out:fade={{duration: $State.noFade ? 0 : 500}} use:inView on:enter={() => $State.placesFirstVisible = true}>
	<div 
		class="raceLabel" 
		style="position:absolute; transform: translate(110px, -5px);"
		transition:fade={{duration: $State.noFade ? 0 : 400}}
	>
		{ttRace}
	</div>
	<svg>
		<defs>
			<linearGradient id="grad_place1" x1="75%" y1="10%" x2="0%" y2="100%">
				<stop stop-color="#F3C9BC"/>
				<stop offset="0.489583" stop-color="#FF3263" stop-opacity="0.75"/>
				<stop offset="1" stop-color="#FF3263" stop-opacity="0.1"/>
			</linearGradient>
			<linearGradient id="grad_place23" x1="75%" y1="10%" x2="0%" y2="100%">
				<stop stop-color="#B3CEED"/>
				<stop offset="0.520833" stop-color="#5C86B5"/>
				<stop offset="1" stop-color="#B3CEED" stop-opacity="0"/>
			</linearGradient>
			<linearGradient id="grad_place410" x1="75%" y1="10%" x2="0%" y2="100%">
				<stop stop-color="#5C86B5"/>
				<stop offset="1" stop-color="#B3CEED" stop-opacity="0"/>
			</linearGradient>
		</defs>
			
			
		
		{#if intro}
			{#each newPoints as {driver, rank, races} (driver+races[0].race)}
				{#if races[0].pos <=10}
				<text 
					class="driverLabel" 
					fill="{rank == 1 ? '#FF3263' : '#9CBCE0'}"
					dominant-baseline="hanging" 
					style="transform: translate({slide ? $State.f_x(0) + 20 :0}px, {$State.f_y(rank) + 6}px); 
						transition: transform 800ms ease"
				>
					{driver}
				</text>
				{/if}
			{/each}
		{/if}
		
		{#each dPoints as {driver, rank, races} (driver)}
			<!-- Safari transform won't always work on text so you need to wrap it in a g element -->
			<g style="transform: translateY({$State.f_y(rank) + 6}px); transition: transform 500ms;" >	
				<text class="driverLabel {driver === ttDriver && !placePlaying ? 'hoverDriver' : ''}" 
					fill="{rank == 1 ? '#FF3263' : '#9CBCE0'}">
					{driver}
				</text>
			</g>

			{#each races as r (driver+r.race)}
				{#if r.points > 0}
				<rect 
					on:mouseover="{() => {showTooltip(driver, r)}}"
					on:focus="{() => {showTooltip(driver, r)}}"
					on:mouseleave ="{hideTooltip}"
					on:blur="{hideTooltip}"
					class = "pointBar"
					data-value = "{r.pos}"
					x = "{padding.left + $State.p_x(r.cumPoints-r.points)}"
					width = "{$State.p_x(r.points)}"
					y = "{r.pos < 4 ? 0 : 2}"
					height = "{r.pos < 4 ? 15 : 13}"
					fill = "url(#{isNaN(r.pos) || r.pos > 3 ? 'grad_place410' : (r.pos === 1 ? 'grad_place1' : 'grad_place23')})"
					stroke-weight="0.5"
					stroke = "black"
					rx = "{Math.min(r.points, 3)}"
					style="transform: translate(0, {$State.f_y(rank) + 6}px); transition: transform 500ms;"
					in:scale
				/>	
				{/if}
			{/each}
			{#each races as r (driver+r.race)}
				{#if r.points > 0 && ttRace === r.race && !placePlaying}
					<rect 
						class = "hoverRect"
						x = "{padding.left + $State.p_x(r.cumPoints-r.points)}"
						width = "{$State.p_x(r.points)}"
						y = "{r.pos < 4 ? 0 : 2}"
						height = "{r.pos < 4 ? 15 : 13}"
						fill = "none"
						stroke-width="2"
						stroke = "white"
						rx = "{Math.min(r.points, 3)}"
						style="transform: translate(0, {$State.f_y(rank) + 6}px); filter: drop-shadow(0px 0px 4px #FFFFFF); -webkit-filter: drop-shadow(0px 0px 4px #FFFFFF);"
						in:fade="{{duration:200}}"
					/>
					{#if ttDriver === driver}
						<text class="hoverPoints"
							fill = '#999'
							font-size = "12px"
							x = "{padding.left + $State.p_x(r.cumPoints-r.points)}"
							y = "{$State.f_y(rank)}"
						>
							{ttPos === 'N' ? 'DNF' : 'P' + ttPos} - {ttPoints} points
						</text>
					{/if}
				{/if}
			{/each}
		{/each}


		<!-- x axis -->
		<g class="axis x-axis">
			{#each xTicks as tick}
				{#if tick !== 100 || !(ttRace === "Emilia Romagna") }
				<g class="tick tick-{ tick }">
					<line y1="15" y2="20" x1="{$State.p_x(tick) + 110}" x2="{$State.p_x(tick) + 110}"></line>
					<text y="10" x="{$State.p_x(tick) + 110}">{tick}</text>
				</g>
				{/if}
			{/each}
		</g>
	</svg>

</div>
</container>

		
	
<style>
	
	container {
		display: block;
		position: absolute;
		width: 100%
	}

	.chart {
		width: 100%;
		max-width: 900px;
		max-height: 450px;
	}	

	svg {
		position: relative;
		width: 100%;
		height: 450px; 
		/* overflow: visible; */
	}

	@media screen and (max-height: 770px) {
		svg {
			height: 400px; 
		}
		.chart {
			max-height: 400px;
		}
	}

	.driverLabel {
    	font-size: 14px;
		transition: fill 200ms;
		dominant-baseline: hanging;
	}

	.raceLabel {
		font-family: Poppins;
		fill: black;
		color: black;
		font-style: italic;
		font-weight: 800;
		font-size: 24px;
		text-transform: uppercase;
		text-shadow: 0px 0px 16px #FF3263;
	}

	.hoverDriver {
		font-weight: 800;
		fill: white;
	}
	
	.hoverRect, .hoverPoints {
		pointer-events: none;
	}

	.pointBar {
		stroke: black;
		stroke-width: 0.5;
	}

	

</style>